import { Link } from "react-router-dom";
import { Phone, Mail, Clock } from "lucide-react";
import { Logo } from "./Logo";
import { PHONE, PHONE_LINK, EMAIL } from "../data";

export const Footer = () => (
  <footer className="relative overflow-hidden border-t border-gold/10 bg-panel" data-testid="site-footer">
    <div className="pointer-events-none absolute -bottom-10 left-1/2 -translate-x-1/2 select-none font-display text-[22vw] leading-none font-extrabold uppercase tracking-tight text-stroke-gold opacity-40">
      EDILKREA
    </div>
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-3">
      <div>
        <div className="flex items-center gap-3">
          <Logo className="h-10 w-10" />
          <span className="leading-none">
            <span className="block font-display font-bold text-lg text-cream">EDILKREA</span>
            <span className="block font-mono text-[10px] tracking-[0.3em] text-gold/80 uppercase">Technoimpianti</span>
          </span>
        </div>
        <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
          Ingegneria edile, ristrutturazioni di pregio e impiantistica d'avanguardia. Costruiamo spazi che durano nel tempo.
        </p>
      </div>

      <div>
        <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-gold/90">Contatti</h3>
        <ul className="mt-5 space-y-3 text-sm text-slate-300">
          <li>
            <a href={PHONE_LINK} data-testid="footer-phone-link" className="inline-flex items-center gap-2 hover:text-gold transition-colors">
              <Phone className="h-4 w-4 text-copper" /> {PHONE}
            </a>
          </li>
          <li>
            <a href={`mailto:${EMAIL}`} data-testid="footer-email-link" className="inline-flex items-center gap-2 hover:text-gold transition-colors">
              <Mail className="h-4 w-4 text-copper" /> {EMAIL}
            </a>
          </li>
          <li className="inline-flex items-center gap-2">
            <Clock className="h-4 w-4 text-copper" /> Lun - Ven: 08:00 - 19:00
          </li>
        </ul>
      </div>

      <div>
        <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-gold/90">Navigazione</h3>
        <ul className="mt-5 space-y-3 text-sm text-slate-300">
          <li><Link to="/servizi" data-testid="footer-link-servizi" className="hover:text-gold transition-colors">Servizi</Link></li>
          <li><Link to="/galleria" data-testid="footer-link-galleria" className="hover:text-gold transition-colors">Galleria Lavori</Link></li>
          <li><Link to="/recensioni" data-testid="footer-link-recensioni" className="hover:text-gold transition-colors">Recensioni</Link></li>
          <li><Link to="/contatti" data-testid="footer-link-contatti" className="hover:text-gold transition-colors">Richiedi un Preventivo</Link></li>
        </ul>
      </div>
    </div>
    <div className="relative border-t border-gold/10">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-slate-500">
        <span>© 2026 Edilkrea Technoimpianti. Tutti i diritti riservati.</span>
        <span className="font-mono tracking-widest uppercase">Costruzioni • Impianti • Design</span>
        <Link to="/admin" data-testid="footer-admin-link" className="text-slate-600 hover:text-gold transition-colors">Area Riservata</Link>
      </div>
    </div>
  </footer>
);
